export default __webpack_public_path__ + "static/media/pushpin2.c7194a8b.png";